//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    /// 商城渠道-
    /// 国内-zh
    /// 海外-en
    /// 日本-ja
    export default {
      name: 'index',
      data () {
        return {
          type: null,
          isShow: false
        }
      },
      computed: {
        shopList () {
          // 示例数据，可根据实际需求替换为接口数据
          return [
            { id: 1, title: '小红书旗舰店', image: '/static/img/xiaohongshu.png', link: 'https://www.xiaohongshu.com/shop/640187b39a611c000123301a' },
            { id: 2, title: '天猫旗舰店', image: '/static/img/tianmao.png', link: 'https://cocinare.world.tmall.com/shop/view_shop.htm?spm=a21xtw.29978516.0.0' },
            { id: 3, title: '京东旗舰店', image: '/static/img/jingdong.png', link: 'https://mall.jd.com/index-19999727.html' },
            { id: 4, title: '抖音旗舰店', image: '/static/img/douyin.png', link: 'https://v.douyin.com/81b97vko2FU/' }
          ]
        }
      },
      mounted () {
        this.type = this.$route.params.type
        if (this.type === 'zh') {
          this.isShow = true
        } else if (this.type === 'en') {
          window.location.href = 'https://www.cocinare.com/'
        } else if (this.type === 'ja') {
          window.location.href = 'https://epeios.jp/'
        }
      },
      methods: {
        goLink (link) {
          window.location.href = link
        }
      }
    }



// WEBPACK FOOTER //
// ./src/components/shop/index.vue